import { MdOutlineClose } from "react-icons/md";

const SwapDetailsModal = ({ isOpen, closeModel, ele }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-40 bg-black bg-opacity-50">
      <div className="relative bg-[#FAFAFA] border-[#D2D2D2] text-black rounded-[6px] lg:max-w-4xl w-11/12">
        <div className="flex justify-between items-start px-6 pt-4">
          <div>
            <h1 className="text-xl font-bold text-black">
              Swap Transaction Details
            </h1>
          </div>
          <div
            className="w-8 h-8 cursor-pointer rounded-full bg-[#ECECEC] hover:bg-[#ECECEC]/80 flex justify-center items-center"
            onClick={closeModel}
          >
            <MdOutlineClose title="Close" />
          </div>
        </div>
        <div className="p-6">
          <div className="mb-3 p-2 bg-blue-50 rounded-lg">
            <div className="text-sm font-medium text-blue-800">
              {ele.referenceId.swapType?.split("_TO_").join(" → ")}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm mb-3">
            <div className="text-gray-600">Original:</div>
            <div className="font-semibold">{ele.referenceId.amount}</div>

            <div className="text-gray-600">Received:</div>
            <div className="font-semibold text-green-600">
              {Number(ele.referenceId.swapAmount || 0).toFixed(4)}
            </div>
          </div>

          <div className="border-t pt-2 mb-3">
            <div className="text-xs text-gray-500 mb-2">Fee Breakdown:</div>
            <div className="space-y-1 text-xs">
              <div className="flex justify-between">
                <span>Network:</span>
                <span className="font-medium">
                  {ele.referenceId.networkFee}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Knowledge:</span>
                <span className="font-medium">
                  {ele.referenceId.knowledgeFee}
                </span>
              </div>
              <div className="flex justify-between">
                <span>Innovation:</span>
                <span className="font-medium">
                  {ele.referenceId.innovationFee}
                </span>
              </div>
              <div className="flex justify-between border-t pt-1 font-semibold">
                <span>Total Fees:</span>
                <span>
                  {(
                    Number(ele.referenceId.networkFee || 0) +
                    Number(ele.referenceId.knowledgeFee || 0) +
                    Number(ele.referenceId.innovationFee || 0)
                  ).toFixed(4)}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-500">Status:</span>
            <div className="flex items-center gap-2">
              <div
                className={`w-2 h-2 rounded-full ${
                  ele.referenceId.status === "pending"
                    ? "bg-yellow-400 animate-pulse"
                    : ele.referenceId.status === "completed"
                    ? "bg-green-400"
                    : "bg-red-400"
                }`}
              ></div>
              <span
                className={`px-2 py-1 rounded-full text-xs font-medium ${
                  ele.referenceId.status === "pending"
                    ? "bg-yellow-100 text-yellow-700"
                    : ele.referenceId.status === "completed"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {ele.referenceId.status?.toUpperCase()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwapDetailsModal;
